function getCookie(name, defaultValue) {
  const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
  const match = document.cookie.match(reg);
  const arr = match;
  if (match) {
    return unescape(arr[2]);
  }
  return defaultValue;
}

export default getCookie;
